import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/axiosInstance";

/* ================================
   FETCH ADVERTISEMENT DETAILS
================================ */
export const fetchAdvtDetails = createAsyncThunk(
  "advertisement/fetchDetails",
  async ({ stateId, districtId, year, month, date }, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/advt/detail", {
        stateId,
        districtId,
        year,
        month,
        date,
      });

      // ✅ BACKEND-CORRECT SHAPE
      return {
        advertisement: res.data.data.advertisement,
        slots: res.data.data.slots,
      };
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Failed to load advertisement details"
      );
    }
  }
);

/* ================================
   BOOK SLOT
================================ */
const base64ToBlob = (base64) => {
  const arr = base64.split(",");
  const mime = arr[0].match(/:(.*?);/)[1];
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  return new Blob([u8arr], { type: mime });
};

export const bookAdvtSlot = createAsyncThunk(
  "advertisement/bookSlot",
  async ({ advtId, slotNumber, date, cardImage }, { rejectWithValue }) => {
    try {
      const formData = new FormData();
      formData.append("advtId", advtId);
      formData.append("slotNumber", slotNumber);
      formData.append("date", date);

      if (cardImage) {
        const blob = base64ToBlob(cardImage);
        formData.append("cardImage", blob, "advertisement.png");
      }

      const res = await api.post("/api/advt/book-slot", formData);
      return res.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Booking failed"
      );
    }
  }
);
